import React from 'react';
import { Modal, message } from 'antd';
import { Cookie } from '$ACTIONS/util';
import { GetPayList } from '$DATA/wallet';
import { sendPiwikUrl, sendPiwikEvent, sendPiwikEventWithEventValue, sendPiwikEventWithEventValueAtUrl } from '$ACTIONS/PiwikUtil';

const renderResubmitAndContent = (paylistRes, setCurrentPayMethod) => {
    let go = method => {
            let method2piwik = {QQ:'DigitalCoin'}
            sendPiwikEventWithEventValue('Deposit',
                'Switchto Available Deposit Payment',
                'Deposit_ODP_ErrorPopup_C_SwitchPayment',
                null,
                [{ customVariableKey:'Deposit_ODP_ErrorPopup_C_SwitchPayment',
                    customVariableValue: method2piwik[method] || method}]);
            Modal.destroyAll();
            setCurrentPayMethod && setCurrentPayMethod(method);
        };
    let lst = ['CTC', 'PPB', 'OA', 'QQ', 'WC', 'BCM'];
    let ui = [n=><div className="isFast" onClick={()=>go('CTC')}><div className="deposit-sprite CTC"></div>{n}</div>,
        n=><div onClick={()=>go('PPB')}><div className="deposit-sprite PPB"></div>{n}</div>,
        n=><div onClick={()=>go('OA')}><div className="deposit-sprite OA"></div>{n}</div>,
        n=><div onClick={()=>go('QQ')} className="isNew"><div className="deposit-sprite QQ"></div>{n}</div>,
        n=><div onClick={()=>go('WC')}><div className="deposit-sprite WC"></div>{n}</div>,
        n=><div onClick={()=>go('BCM')}><div className="deposit-sprite BCM"></div>{n}</div>];
    let ele = Array(6);
    if (paylistRes?.isSuccess) {
        if (Array.isArray(paylistRes.result?.paymentMethods)) {
            paylistRes.result.paymentMethods.map(v=>{
                let i = -1, code = v.code;
                if (lst.includes(code)) { i=lst.indexOf(code); }
                if (i>=0) {
                    ele[i] = ui[i] && ui[i](v.name);
                }
            });
        }
    }
    if (!ele.filter(v=>v).length) {
        return <div style={{width:'100%'}}>抱歉，目前暂无可存款银行。您可以尝试增加存款金额，或者选择其他存款方式。</div>
    }
    ele = <div className="suggestion-list-when-no-ODP-banks-wrap">{ele}</div>;
    return <div style={{width:'100%'}}>抱歉，目前暂无可存款银行。 您可以尝试增加存款金额，或使用如以下存款方式：{ele}</div>
};
export const renderP115001Content = (paylistRes, setCurrentPayMethod) => {
    return renderResubmitAndContent(paylistRes, setCurrentPayMethod)
}

export const P115001onOkFunc = () => {
    sendPiwikEvent('Deposit', 'Go to Deposit', 'Deposit_ODP_ErrorPopup_C_Resubmit');
    Modal.destroyAll();
};

export const triggerPercentPiwik = val => {
    // if (triggerPercentPiwik.didRun) { return; }
    // triggerPercentPiwik.didRun = true;
    if (typeof val !== 'number') {
        val = parseFloat(val);
    }
    val = parseInt(val, 10); // remove all float,  2.88889 -> 2
    let aryCustomVariable = [{customVariableKey:'Deposit_ODP_Loading_Progress', customVariableValue: val + '%'}]
    sendPiwikEventWithEventValueAtUrl('odp_progress_bar_popup', 'ODP Progress Bar Popup',
            'Deposit', 'Deposit ODP Loading', 'Deposit_ODP_Loading', false, aryCustomVariable);
};

class PaymentProgressModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			time: 0,
            percent: 0, // 目前進度百分比
            fraction: "(1/5) 正在連接...", // 顯示階段性文字說明
        };
		this.timer = null;
        this.reSubmitModalCalled = false;
		this.startCountDown = this.startCountDown.bind(this); // 倒计时
		this.reSubmitModal= this.reSubmitModal.bind(this);
		// triggerPercentPiwik.didRun = false; // init
	}

	// componentDidUpdate(prevProps, prevState) {
	// 	if (prevState.visible !== this.props.visible && this.props.visible && Cookie('loadingTime')) {
	// 		this.startCountDown();
	// 	}
	// 	if (prevState.visible !== this.props.visible && !this.props.visible && Cookie('loadingTime')) {
	// 		Cookie('loadingTime', null);
	// 		//clearInterval(this.timeTimer);
	// 		clearInterval(this.timer);
	// 	}
	// }

	componentDidMount() {
		this.startCountDown();
	}

	componentWillUnmount() {
		Cookie('loadingTime', null);
		//clearInterval(this.timeTimer);
        this.clearTimer();
	}

	startCountDown() {
		this.clearTimer();
        this.timer = setInterval(this.updateProgress, 1000)
	}

    clearTimer() {
        if(this.timer) {
            clearInterval(this.timer)
        }
    }


    formatTime = (time) => {
		const minutes = Math.floor(time / 60);
		const seconds = time % 60;
		return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
	};

    updateProgress = () => {
        try {
            this.setState(({ percent, time }) => {
                if (percent >= 100) {
                    this.closeModal();
                    return;
                }

                const incrementPerSecond = 100 / 60; // 計算每秒需要增加的百分比
                const newPercent = percent + incrementPerSecond; // 更新當前進度百分比
                const newFraction = this.calculateFraction(newPercent); // 對應的進度階段文字
                const newSeconds = time + 1; // 每次更新時秒數增加1

                return {
                    percent: newPercent,
                    fraction: newFraction,
                    time: newSeconds,
                };
            }, () => {
                this.props.setPaymentProgressModalPercent && this.props.setPaymentProgressModalPercent(this.state.percent);
            });
        } catch (e) {
            console.error('error in updateProgress:', e);
            this.closeModal();
        }
    }
    
    // 根據當前百分比計算階段性文字說明
    calculateFraction = (percent) => {
        // 0% ~ 30%
        if (percent <= 30) return "(1/5) 正在连接...";
        // 31% ~ 50%
        if (percent > 30 && percent <= 50) return "(2/5) 收集账户中";
        // 51% ~ 75%
        if (percent > 50 && percent <= 75) return "(3/5) 审核账户...";
        // 76% ~ 90%
        if (percent > 75 && percent <= 90) return "(4/5) 渠道安全评估...";
        // 91% ~ 100%
        if (percent > 90 && percent <= 100) return "(5/5) 最终账户审核..."
        return "(5/5) 最终账户审核..."; // 保持最後的狀態不變
    }

    closeModal = () => {
        triggerPercentPiwik(this.state.percent); // while closing by self, that percent should be '100%'.

        this.clearTimer();
        this.props.setVisible(false);
        this.reSubmitModal();
    }

    reSubmitModal = () => {
        if (this.reSubmitModalCalled) {
            return;
        }
        this.props.setNeedShowP115001False();
                   // ^^^^^^^^^^^^^^^^^^ avoid repeated P115001 modal showing
        this.reSubmitModalCalled = true;
        let _title = '温馨提醒';
        let _okText = '重新提交';
        let _content = '';
        let _onOkFunc = P115001onOkFunc;
        let _modalWidth = undefined;
        let _hasExchangeHintClassName = false;
        this.props.setLoading(true);
        sendPiwikUrl(`ODP_deposit_error_popup`, `ODP Deposit Error Popup`);
        GetPayList(paylistRes=>{
            this.props.setLoading(false);
            _content = renderResubmitAndContent(paylistRes, this.props.setCurrentPayMethod);
            _popupErrorModal();
        }, ()=>{
            this.props.setLoading(false);
            _content = renderResubmitAndContent();
            _popupErrorModal();
        });

        function _popupErrorModal(){
        Modal.info({
            className: 'confirm-modal-of-public suggestion-list-when-no-ODP-banks-modal hide-ant-modal-close-x-modal',
            icon: <div />,
            title: _title,
            width: 400,
            okText: _okText,
            okButtonProps: {
                shape: 'round'
            },
            onOk: _onOkFunc,
            content: (
                <div className={(_hasExchangeHintClassName ? "exchange-hint " : "")+"ODPmodals"}>
                    <div className="content" style={{ textAlign: 'left' }}>
                        {_content}
                    </div>
                </div>)
        });
        }
    }

    render() {
        const {
            visible,
        } = this.props;
		return (
			<React.Fragment>
				<Modal
					title={``}
					visible={visible}
					footer={null}
					className="showInfoModal depositLoadingModal progressModal"
					centered={true}
				>
                    <div className="loadimg popup-content">
                        <div className="progress-fraction-text progress-bar-text">{this.state.fraction}</div>
                        <progress className="progress-bar" value={this.state.percent} max="100"/>
                        <div className="progress-bar-container">
                            {
                                typeof this.state.percent === 'number' &&
                                <div className="progress-text">{Math.floor(this.state.percent)}%</div>
                            }
                            {this.state.percent >= 50 && (
                                <div className="progress-waitTime-text">最多等待时间 1 分钟</div>
                            )}
                        </div>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}

export default PaymentProgressModal;
